export const getClientTimeZone = () => {
  try {
    const format = new Intl.DateTimeFormat();
    const timeZone = format.resolvedOptions().timeZone;
    return timeZone;
  } catch (error) {
    return 'Asia/Colombo';
  }
};
